import { Shield, Target, Flame } from 'lucide-react';
import type { SuggestionMode } from '@/types/api';

const MODES: {
  value: SuggestionMode;
  label: string;
  desc: string;
  icon: React.ReactNode;
}[] = [
  {
    value: 'conservative',
    label: 'Conservative',
    desc: 'Protect capital, reduce risk',
    icon: <Shield size={16} />,
  },
  {
    value: 'optimal',
    label: 'Optimal',
    desc: 'Best risk-adjusted returns',
    icon: <Target size={16} />,
  },
  {
    value: 'aggressive',
    label: 'Aggressive',
    desc: 'Maximize returns, higher risk',
    icon: <Flame size={16} />,
  },
];

interface ModeSelectorProps {
  value: SuggestionMode;
  onChange: (mode: SuggestionMode) => void;
}

export function ModeSelector({ value, onChange }: ModeSelectorProps) {
  return (
    <div>
      <label className="block text-[10px] font-semibold text-ink-3 mb-1.5">
        AI Suggestion Mode
      </label>
      <div className="grid grid-cols-3 gap-2">
        {MODES.map((m) => (
          <button
            key={m.value}
            type="button"
            onClick={() => onChange(m.value)}
            className={`rounded-lg p-3 text-center transition-all cursor-pointer border ${
              value === m.value
                ? 'border-orange bg-orange-bg'
                : 'border-glass-border bg-surface hover:border-orange/30'
            }`}
          >
            <div className={`mx-auto mb-1.5 w-fit ${value === m.value ? 'text-orange' : 'text-ink-3'}`}>
              {m.icon}
            </div>
            <p className={`text-[10px] font-bold ${value === m.value ? 'text-orange' : 'text-ink-2'}`}>
              {m.label}
            </p>
            <p className="text-[8px] text-ink-4 mt-0.5">{m.desc}</p>
          </button>
        ))}
      </div>
    </div>
  );
}
